module.exports = __webpack_public_path__ + "static/img/PencilsForKids_Logo.c3c43d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PencilsForKids_Logo.svg
// module id = 337
// module chunks = 2